import React, { Component } from 'react';

class ViewMore extends Component {
  render() {
    const { className, searchString } = this.props;

    return (
      <div className={className}>
        {className === "main-results-header-container" &&
          <h6 className="top-five">Top Suggested Results</h6>
        }
        <h6 className="view-all">
          <a className="more-link" href={`/search?search=${searchString}`}>View all results</a>
        </h6>
      </div>
    )
  }
}

export default ViewMore;



// WEBPACK FOOTER //
// ./src/ViewMore.js